import React from "react"
import styled from "styled-components"
import PropTypes from "prop-types"
import Input from "./Input"
import Text from "./Text"
import Gap from "./Gap"
import Col from "./Col"

const TextArea = styled(Input).attrs(() => ({
  as: "textarea",
}))`
  resize: none;
  height: 120px;
  padding-top: 8px;
`

const TextAreaField = ({ label, hasError, error, ...props }) => (
  <Col>
    {error || hasError ? (
      <Text.Error>{error || label}</Text.Error>
    ) : (
      <Text>{label}</Text>
    )}
    <Gap gap="4px" />
    <TextArea hasError={error || hasError} {...props} />
  </Col>
)

TextAreaField.defaultProps = {
  label: "",
  hasError: false,
  error: "",
}

TextAreaField.propTypes = {
  label: PropTypes.string,
  hasError: PropTypes.bool,
  error: PropTypes.string,
}

export default TextAreaField
